import React from "react";

type ContainerVariant = "full" | "content";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  variant?: ContainerVariant;
}

const Container: React.FC<ContainerProps> = ({ children, className = "", variant = "full" }) => {
  const variants = {
    full: "mx-auto w-[90vw] max-w-screen-2xl",
    content: "mx-auto max-w-[90%] md:max-w-2xl lg:max-w-4xl xl:max-w-6xl",
  };

  return <div className={`${variants[variant]} ${className} `}>{children}</div>;
};

export default Container;
